import PopupModal, {FADE_TIME, OPACITY} from './PopupModal';

export {FADE_TIME, OPACITY}
export default PopupModal;
